import axios from 'axios';

const API_BASE_URL = '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 600000, // 10 minutes timeout for large files
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid, clear it and reload page
      localStorage.removeItem('token');
      window.location.reload();
      return Promise.reject(new Error('Authentication expired. Please login again.'));
    }
    return Promise.reject(error);
  }
);

export const uploadFileAndPredict = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await api.post('/predict', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.detail || 'Server error occurred');
    } else if (error.request) {
      throw new Error('No response from server. Please check if the backend is running.');
    } else {
      throw new Error('Error uploading file: ' + error.message);
    }
  }
};

export const fetchDataSourceTimestamps = async () => {
  const res = await api.get('/get_datasource_timestamps');
  return res.data;
};

export const dispatchWorkflow = async (workflowFile, workflowName) => {
  try {
    const response = await api.post('/github/workflows/dispatch', {
      workflow_file: workflowFile,
      workflow_name: workflowName || null,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.detail || 'Failed to trigger workflow');
    } else if (error.request) {
      throw new Error('No response from server. Please check if the backend is running.');
    } else {
      throw new Error('Error triggering workflow: ' + error.message);
    }
  }
};

export default api;